import FinancialTableRow from './FinancialTableRow';

export default FinancialTableRow;
